import { render, staticRenderFns } from "./newYYZZ.vue?vue&type=template&id=7825a287&scoped=true"
import script from "./newYYZZ.vue?vue&type=script&lang=js"
export * from "./newYYZZ.vue?vue&type=script&lang=js"
import style0 from "./newYYZZ.vue?vue&type=style&index=0&id=7825a287&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825a287",
  null
  
)

export default component.exports